// Product types whose price can't be haggled over: tickets and digital goods have a fixed face value,
// services/subscription plans are priced by zone/schedule/plan, Pick & Pack and configurable products
// get their price from what the customer assembles. Mirrors NON_NEGOTIABLE_PRODUCT_TYPES in
// backend/shop/logic/negotiations.py — the backend rejects these regardless of the scope setting.
export const NON_NEGOTIABLE_PRODUCT_TYPES = ['ticket', 'digital', 'service', 'subscription_plan', 'pick_pack', 'configurable'];

export function isNegotiationAllowedForProduct(siteConfig: any, product: any): boolean {
    if (!siteConfig || !siteConfig.price_negotiation_enabled) return false;
    if (NON_NEGOTIABLE_PRODUCT_TYPES.includes(product?.product_type)) return false;
    const scope = siteConfig.price_negotiation_scope || 'all';
    if (scope === 'all') return true;

    const catIds: number[] = Array.isArray(siteConfig.price_negotiation_category_ids)
        ? siteConfig.price_negotiation_category_ids.map(Number)
        : [];
    const prodIds: number[] = Array.isArray(siteConfig.price_negotiation_product_ids)
        ? siteConfig.price_negotiation_product_ids.map(Number)
        : [];

    const productCatIds: number[] = Array.isArray(product?.categories)
        ? product.categories.map((c: any) => Number(c.id ?? c))
        : (product?.category_id ? [Number(product.category_id)] : []);
    const productId = Number(product?.id);

    if (scope === 'categories') {
        return productCatIds.some(id => catIds.includes(id));
    }
    if (scope === 'products') {
        return prodIds.includes(productId);
    }
    if (scope === 'exclude_categories') {
        return !productCatIds.some(id => catIds.includes(id));
    }
    if (scope === 'exclude_products') {
        return !prodIds.includes(productId);
    }
    return true;
}
